<div
  class="card-container"
  [ngClass]="{ selected: selected, unverified: isCreditCardValidationEnabled && !paymentAccount.verified }"
  id="paymentAccountDetails-container-card-{{ paymentAccount.id }}"
  *ngIf="paymentAccount"
>
  <div class="info">
    <div class="row verification">
      <p id="paymentAccountDetails-text-cardAlertMsg-{{ paymentAccount.id }}">
        <ng-container *ngIf="isUnverified">
          <mat-icon class="material-icons-outlined">info</mat-icon> Needs verification. Select card to verify.
        </ng-container>

        <ng-container *ngIf="isExpired">
          <mat-icon class="material-icons-outlined">info</mat-icon> Expired
        </ng-container>
        &nbsp;
      </p>
    </div>
    <div class="row description">
      <p class="nickname" id="paymentAccountDetails-heading-id-{{ paymentAccount.id }}" data-private>
        {{ paymentAccount.userDescription }}
      </p>
      <img id="paymentAccountDetails-image-cardLogo-{{ paymentAccount.id }}" style="height: 25px" [src]="cardImageHtml" alt="Card Logo" />
      <button
        id="paymentAccountDetails-button-edit-{{ paymentAccount.id }}"
        mat-icon-button
        color="primary"
        (click)="handleEditPaymentAccount($event)"
        aria-label="Edit Payment Account"
      >
        <mat-icon class="material-icons-outlined">create</mat-icon>
      </button>
    </div>
    <p
      class="number"
      id="paymentAccountDetails-text-cardNumber-{{ paymentAccount.id }}"
      [innerHTML]="getHiddenCardNumberWithEnding(paymentAccount)"
      data-private
    ></p>
    <div class="row">
      <div>
        <small class="contrast-gray">Card Holder</small>
        <p id="paymentAccountDetails-text-nameOnCard-{{ paymentAccount.id }}" data-private>
          {{ paymentAccount.billingFirstName }} {{ paymentAccount.billingLastName }}
        </p>
      </div>
      <div class="expires">
        <small class="contrast-gray">Expires</small>
        <p id="paymentAccountDetails-text-expirationDate-{{ paymentAccount.id }}" data-private>{{ formatCardExpiration(paymentAccount.cardExpiration) }}</p>
      </div>
    </div>
    <div class="created-by">
      <small id="paymentAccountDetails-text-createdBy-{{ paymentAccount.id }}"> Created by: {{ paymentAccount.createdBy }} </small>
    </div>
  </div>
</div>
